import { useNavigate } from 'react-router-dom';
import {
  Container,
  Box,
  Typography,
  Card,
  Button,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import { styled } from '@mui/material/styles';

import ArrowBackTwoToneIcon from '@mui/icons-material/ArrowBackTwoTone';
import ShieldTwoToneIcon from '@mui/icons-material/ShieldTwoTone';
import LockTwoToneIcon from '@mui/icons-material/LockTwoTone';
import VisibilityTwoToneIcon from '@mui/icons-material/VisibilityTwoTone';

const PolicyCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(4),
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[1]
}));

export default function PrivacyPolicy() {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ py: 5 }}>
      {/* HEADER NAVIGATION ACTION */}
      <Box
        display="flex"
        mb={4}
        alignItems="center"
        justifyContent="space-between"
      >
        <Box display="flex" alignItems="center">
          <Button
            variant="outlined"
            startIcon={<ArrowBackTwoToneIcon />}
            onClick={() => navigate(-1)}
            sx={{ textTransform: 'none', mr: 2 }}
          >
            Go Back
          </Button>
          <Box>
            <Typography variant="h3" component="h1" gutterBottom>
              Data Protection & Privacy
            </Typography>
            <Typography variant="subtitle2" color="text.secondary">
              Last Updated: June 2026
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* CORE CONTENT BLOCK */}
      <PolicyCard>
        <Typography variant="h4" gutterBottom>
          Account Activation Parameters
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          We do not store any personal data beyond what is required to activate
          your account.
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Typography variant="h4" gutterBottom>
          Data Liquidation & Purging
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          You may delete your data at any time.
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Typography variant="h4" gutterBottom>
          Security Thresholds & External Breach Policy
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          While we use strong security measures, we cannot guarantee absolute
          protection and are not responsible for external breaches.
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Typography variant="h4" gutterBottom>
          Anonymous Configuration Options
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          You may use an anonymous identity or nickname if you prefer.
        </Typography>

        <Box mt={4} pt={2} display="flex" justifyContent="center">
          <Typography variant="subtitle2" color="text.disabled" align="center">
            Secured by Global Framework Platform Identity Systems.
          </Typography>
        </Box>
      </PolicyCard>
    </Container>
  );
}
